import "./assets/js/nav-pills.js";
import "./assets/scss/soft-ui-dashboard.scss";

export default {
  // eslint-disable-next-line prettier/prettier
  install() {}
};
